import React from "react";
import PropTypes from "prop-types";
import InnerHTML from "dangerously-set-html-content";

const DeliveryNote = ({
    additionalText = "",
    deliveryInfo,
    sectionHeading,
}) => (
    <div className="grid">
        <div className="col col--12">
            <h3 className="-type--regular -margin-bottom--5">
                {sectionHeading}
            </h3>
            {additionalText && (
                <p className="-margin-top--0">{additionalText}</p>
            )}
        </div>
        <div className="col col--12 -user-html-content">
            {/* We are using InnerHTML here since this input is a WYSIWYG */}
            <InnerHTML html={deliveryInfo} />
        </div>
    </div>
);

DeliveryNote.propTypes = {
    additionalText: PropTypes.string,
    deliveryInfo: PropTypes.string.isRequired,
    sectionHeading: PropTypes.string.isRequired,
};

export default DeliveryNote;
